/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from "@ember/component";
import { computed } from "@ember/object";
import { attributeBindings, tagName } from "@ember-decorators/component";

@tagName("input")
@attributeBindings(
  "name",
  "type",
  "value",
  "checked:checked",
  "disabled:disabled"
)
export default class DRadioButton extends Component {
  type = "radio";

  click() {
    const value = this.element.value;

    if (this.onChange) {
      this.onChange(value);
    } else {
      if (this.selection === value) {
        this.set("selection", undefined);
      }
      this.set("selection", value);
    }
  }

  @computed("value", "selection")
  get checked() {
    return this.value === this.selection;
  }
}
